var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MainGroupFunctions, SubGroupFunctions, FilterPredicate } from "../../../typings";
import { observable, observe, computed, action } from "mobx";
import { EventsBySportIdRequest } from "sb-bff-integration";
import { MainGroupConfiguration, SubGroupConfiguration, CardType } from "../../../data";
import { getISODate, addHours, addDays, getEventTitle, getDailyHours, getDictPhrase, ComponentManager } from "../../../helpers";
import { StreamingFilterBlockConstant } from "../../../constants";
import { DeviceDetect } from "sb-resp-utils";
import { componentManagerConfig } from "../config";
import { toJS } from "mobx";
export class EventListPresenterState {
    constructor(provider, options) {
        this.EVENTS_CHUNK_SIZE = 20;
        this.displayMarkets = (eventId) => {
            return this.provider.data.markets.filter(x => x && x.eventId === eventId);
        };
        this.filterEventsByType = (events) => {
            const eventsWithMarkets = events.filter(this.filterOutrightWithMarkets);
            if (this.showLiveFixturesAndOutrights) {
                return eventsWithMarkets;
            }
            const fixtureEvents = eventsWithMarkets.filter(this.isFixture);
            return fixtureEvents.length ? fixtureEvents : eventsWithMarkets;
        };
        this.filterOutrightWithMarkets = (ev) => {
            return ev.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString() ? this.displayMarkets(ev.id).length > 0 : true;
        };
        this.provider = provider;
        this.options = options;
        this.deviceDetect = DeviceDetect.getInstance();
        this.sports = provider.sports;
        this.dateRange = provider.dateRange;
        this.mainGroupBy = options.cms.MainGroupBy;
        this.subGroupBy = options.cms.SubGroupBy;
        this.isFavoritesEnabled = this.provider.isFavoritesEnabled;
        this.isInFavoritesState = this.provider.isInFavoritesState;
        this.showLiveFixturesAndOutrights = options.cms.ShowLiveFixturesAndOutrights;
        this.loader = this.provider.loader;
        this.componentManager = new ComponentManager(this.showLeagueInEventCard, this.options.cms.NumberOfSelectionsToShow, this.shouldShowOutrightSubheading, this.deviceDetect, this.options.dataProvider.componentManagerConfig || componentManagerConfig);
        this.filterManager = provider.filterManager;
        this.disposers = [];
        this.showOddBtns = false;
    }
    get isMiniEventCard() {
        return this.provider.isMiniEventCard;
    }
    shouldRenderSubheading(id) {
        return !this.displayEvents(id).length && !this.showFavoritesSection;
    }
    get tooltipMessage() {
        return this.showOddBtns ? this.options.dict.HideAllOdds : this.options.dict.ShowAllOdds;
    }
    toggleOddsBtnOnClick() {
        this.showOddBtns = !this.showOddBtns;
        return this.showOddBtns;
    }
    activate() {
        this.attachObservable();
        this.provider.activate();
    }
    deactivate() {
        this.provider.deactivate();
        this.dettachObservable();
    }
    attachObservable() {
        this.disposers = [
            observe(this.provider, this.updateProviderProps)
        ];
    }
    updateProviderProps(change) {
        let provider = change.object;
        this.sports = provider.sports;
        this.dateRange = provider.dateRange;
        this.isFavoritesEnabled = provider.isFavoritesEnabled;
        this.isInFavoritesState = provider.isInFavoritesState;
        this.loader = provider.loader;
    }
    dettachObservable() {
        this.disposers.map(x => typeof x === "function" && x());
        this.disposers = [];
    }
    get isLoading() {
        return this.isGroupedByTime ? this.loader.isFirstLoad : this.loader.isLoading;
    }
    get hasLoadEvents() {
        return !this.isLoading && this.provider.data.events.length > 0;
    }
    get preLiveOutrightShouldExpand() {
        return this.provider.data.markets.length === 1;
    }
    get showLeagueInEventCard() {
        return this.options.cms.ShowLeagueInEventCard && this.mainGroupBy !== MainGroupConfiguration.League
            && this.subGroupBy !== SubGroupConfiguration.League;
    }
    addToSlipTranspiler(market, selection) {
        let items = [{ eventId: market.eventId, marketId: market.id, selectionId: selection.id, type: "Regular" }];
        if (selection.isSelectionInBetslip) {
            return this.provider.sendBsUtilItemsRemoveMessage(items);
        }
        return this.provider.sendBsUtilItemsAddMessage(items);
    }
    openGameTranspiler(event, ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        let openGameData = this.provider.getOpenGameData(event, ev);
        openGameData &&
            this.options.navHandler.OpenGame(openGameData.event, openGameData.id, openGameData.isLive, openGameData.evTypeForGameBlock, openGameData.shouldHideSidePanels, openGameData.branchID);
    }
    manageFavorites(event, ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.provider.manageFavorites(event);
    }
    openStatTranspiler(statisticsEventId, ev) {
        ev && ev.preventDefault();
        ev && ev.stopPropagation();
        this.provider.openStats(statisticsEventId, ev);
    }
    openLiveStream(eventId, ev) {
        if (this.options.dataProvider.isLiveStreamHandlerEnabled && !this.isMiniEventCard) {
            this.provider.openLiveStream(eventId);
            ev && ev.preventDefault();
            ev && ev.stopPropagation();
        }
    }
    changeSubGrouping(newGrouping) {
        this.subGroupBy = newGrouping;
        this.componentManager.showLeagueInEventCard = this.showLeagueInEventCard;
    }
    openLeagueTranspiler(sportId, leagueId, ev, element) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        this.options.navHandler.OpenLeague(ev, leagueId, sportId, element);
    }
    openViewAllLiveLink(ev) {
        ev && ev.stopPropagation();
        ev && ev.preventDefault();
        let sportId = this.sports.length ? this.sports[0] : 0;
        if (this.filterManager.isCurrentMainFilter(FilterPredicate.LiveStreaming)) {
            sportId = StreamingFilterBlockConstant;
        }
        this.options.navHandler.OpenGame(ev, 0, true, 0, 0, sportId);
    }
    getViewAllLiveLink() {
        return this.options.navHandler.Navigation.getLiveBettingLink();
    }
    // General display functions
    get displayMainHeadings() {
        return this[MainGroupFunctions[this.mainGroupBy].headings](this.sports[0])
            .filter((main) => this.displayEventByMainGrouping(main.id).length > 0);
    }
    displaySubheadings(sportId) {
        let subheadings = this[SubGroupFunctions[this.subGroupBy].headings](sportId);
        return subheadings.map((s) => {
            const sub = toJS(s);
            sub.displayEvents = this.displayEvents(sub.id);
            return sub;
        }).filter((sub) => sub.displayEvents.length || this.isFavouriteLeague(sub));
    }
    displayEvents(id) {
        const filteredEvents = this.shouldHideSubheadings ?
            this[MainGroupFunctions[this.mainGroupBy].events](id) :
            this[SubGroupFunctions[this.subGroupBy].events](id);
        return this.filterEventsByType(filteredEvents);
    }
    // Display functions depending on current grouping
    // Main headings and Subheadings
    displayAllHeading(id) {
        return [{
                id: this.sports[0],
                sportId: this.sports[0],
                name: getDictPhrase(this.options.dict, "DisplayAllEvents")
            }];
    }
    displaySports(id) {
        let sportHeadings = [];
        this.sports.map((sportId) => {
            const event = this.provider.data.events.find((ev) => ev.sportId === sportId);
            event && sportHeadings.push({
                id: event.sportId,
                sportId: event.sportId,
                name: event.sportName
            });
        });
        return sportHeadings;
    }
    displayLeagues(sportId) {
        const currentSportId = sportId;
        return this.provider.data.leagues.filter((l) => l.sportId === currentSportId);
    }
    displayHours(sportId) {
        const timeFormat = this.options.dataProvider.shortTimeFormat;
        if (this.dateRange && this.dateRange.from) {
            const from = this.dateRange.from;
            const now = addHours(new Date(), this.provider.timeZone);
            const end = addDays(this.dateRange.from, 1);
            const isToday = from <= now && now <= end;
            if (isToday) {
                let hours = getDailyHours(now.getUTCHours(), timeFormat);
                hours[0].name = this.options.dict.NextUp;
                return hours;
            }
        }
        return getDailyHours(0, timeFormat);
    }
    displayDays(id) {
        let dates = {};
        this.provider.data.events.forEach((event) => {
            const evDate = getISODate(event.startEventDate, this.provider.timeZone);
            if (evDate) {
                const dateId = this.getDayId(evDate);
                dates[dateId] = {
                    id: dateId.toString(),
                    sportId: this.sports[0].toString(),
                    name: getDictPhrase(this.options.dict, `day-${evDate.getDay()}`),
                    subname: `${evDate.getDate()} ${getDictPhrase(this.options.dict, `month-${evDate.getMonth()}`)}`
                };
            }
        });
        return Object.keys(dates).map(key => dates[key]);
    }
    displayAllEvents(id) {
        const outrights = this.getOutrightsWithMbn(this.provider.data.events);
        return outrights.map(outright => {
            return {
                id: outright.e.id,
                sportId: outright.e.sportId,
                name: getEventTitle(outright.e, outright.m, this.options.dict.EachWayTag),
                mbnIcon: outright.e.mbnIcon
            };
        });
    }
    getOutrightsWithMbn(events) {
        return events.reduce((arr, event) => {
            const markets = this.displayMarkets(event.id);
            (markets.length > 0) && arr.push({
                e: Object.assign(Object.assign({}, event), { mbnIcon: markets[0].mbnIcon }),
                m: markets[0]
            });
            return arr;
        }, []);
    }
    // Events
    displayEventsBySportId(sportId) {
        return this.provider.data.events.filter(event => event.sportId === sportId);
    }
    displayEventsByLeague(leagueId) {
        let events = this.provider.data.events.filter(ev => ev.leagueId === leagueId);
        if (this.isInFavoritesState) {
            return this.filterFavoriteEvents(events, true);
        }
        if (this.showFavoritesSection) {
            return this.filterFavoriteEvents(events, false);
        }
        return events;
    }
    displayEventsByTime(hour) {
        return this.provider.data.events.filter(ev => {
            const evDate = getISODate(ev.startEventDate, this.provider.timeZone);
            return evDate && evDate.getHours().toString() === hour;
        });
    }
    displayEventsByDay(id) {
        return this.provider.data.events.filter((event) => {
            const evDate = getISODate(event.startEventDate, this.provider.timeZone);
            const dateId = evDate && this.getDayId(evDate).toString();
            return dateId === id;
        });
    }
    displayEventByMainGrouping(id) {
        const events = this[MainGroupFunctions[this.mainGroupBy].events](id);
        if (this.isInFavoritesState) {
            return this.filterFavoriteEvents(events, true);
        }
        return events;
    }
    displayEventsById(id) {
        let event = this.provider.data.events.find((ev) => ev.id === id);
        return event ? [event] : [];
    }
    displayNoFilteredEvents(id) {
        return this.provider.data.events;
    }
    get shouldHideSubheadings() {
        return this.subGroupBy === SubGroupConfiguration.None;
    }
    get displayFavoriteEvents() {
        return this.provider.data.events.filter((ev) => ev.isInFavorites);
    }
    displayFavoriteEventsByLeague(id) {
        return this.provider.data.events.filter((ev) => ev.isInFavorites && ev.leagueId === id);
    }
    get displayFavoriteLeagues() {
        const favoriteLeagues = this.displayFavoriteEvents.reduce((acc, ev) => {
            acc[ev.leagueId] = { id: ev.leagueId, name: ev.leagueName, sportId: ev.sportId };
            return acc;
        }, {});
        return Object.keys(favoriteLeagues).map(key => favoriteLeagues[key]);
    }
    get showFavoritesSection() {
        return this.isFavoritesEnabled
            && !this.isInFavoritesState
            && this.displayFavoriteEvents.length > 0
            && this.subGroupBy === SubGroupConfiguration.League;
    }
    filterFavoriteEvents(events, showFavorites) {
        return events.filter((ev) => showFavorites ? ev.isInFavorites : !ev.isInFavorites);
    }
    get shouldShowOutrightSubheading() {
        return this.mainGroupBy !== MainGroupConfiguration.Event || this.subGroupBy !== SubGroupConfiguration.None;
    }
    get isGroupedByTime() {
        return this.subGroupBy === SubGroupConfiguration.Time;
    }
    getSportCardType(sportId) {
        return this.getCardConfiguration(sportId).cardType;
    }
    getCardConfiguration(sportId) {
        return this.provider.getCardConfigBySportId(sportId, this.isMiniEventCard) || this.provider.getCardConfigBySportId("0", this.isMiniEventCard);
    }
    getMarketTemplates(sportId) {
        let cardItem = this.getCardConfiguration(sportId);
        let templates = cardItem.markets.map(m => m.template);
        return templates;
    }
    generateSubheadingId(mainHeadingId, subheadingId) {
        const dateId = (this.dateRange && this.dateRange.from) ? `${this.dateRange.from.getDate()}-` : "";
        return `${mainHeadingId}-${dateId}${subheadingId}`;
    }
    shouldShowCustomSubheading(mainheading) {
        return this.deviceDetect.isDesktop
            && this.subGroupBy === SubGroupConfiguration.None
            && this.shouldShowNamesInHeading(mainheading)
            && this.displayEventByMainGrouping(mainheading.id).some((ev) => ev.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString());
    }
    shouldShowNamesInHeading(mainheading, isMainHeading) {
        const cardType = this.getSportCardType(mainheading.sportId);
        const shouldShowForDevice = this.deviceDetect.isDesktop && !this.isMiniEventCard;
        const shouldShowForCard = isMainHeading ? cardType === CardType.Multiview : (cardType === CardType.American || cardType === CardType.Multiview);
        return shouldShowForDevice && shouldShowForCard && this.shouldShowNamesInHeadingForEvents;
    }
    get shouldShowNamesInHeadingForEvents() {
        if (this.mainGroupBy === MainGroupConfiguration.Event) {
            // Only outrights
            return false;
        }
        return this.provider.data.events.some(this.isFixture);
    }
    isFixture(ev) {
        return ev.type !== EventsBySportIdRequest.EventTypesEnum.Outright.toString();
    }
    getEventsHeight(events) {
        let eventChunkHeights = [];
        const eventToShow = Math.min(events.length, this.options.cms.ExpandedEvents);
        let baseMinHeight = 0;
        let currentEvent = {};
        let isFirstChunk = true;
        let offsetToAdd = 0;
        for (let current = 0; current < eventToShow;) {
            baseMinHeight = 0;
            let numberOfEvents = Math.min(eventToShow - current, this.EVENTS_CHUNK_SIZE);
            for (let i = 0; i < numberOfEvents; i++) {
                currentEvent = events[current + i];
                let markets = this.displayMarkets(currentEvent.id);
                offsetToAdd = isFirstChunk
                    ? this.componentManager.getOffsetValue(currentEvent)
                    : 0;
                baseMinHeight += this.componentManager.getComponentHeight(currentEvent, markets) + offsetToAdd;
                isFirstChunk = false;
            }
            eventChunkHeights.push(baseMinHeight);
            let max = current + this.EVENTS_CHUNK_SIZE;
            current = Math.min(max, eventToShow);
        }
        return eventChunkHeights;
    }
    getDayId(evDate) {
        return new Date(evDate.getFullYear(), evDate.getMonth(), evDate.getDate(), 0, 0, 0).getTime();
    }
    isFavouriteLeague(sub) {
        return this.showFavoritesSection && this.displayFavoriteEvents.find(ev => ev.leagueId === sub.id);
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], EventListPresenterState.prototype, "sports", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EventListPresenterState.prototype, "dateRange", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], EventListPresenterState.prototype, "mainGroupBy", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], EventListPresenterState.prototype, "subGroupBy", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], EventListPresenterState.prototype, "isFavoritesEnabled", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], EventListPresenterState.prototype, "isInFavoritesState", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], EventListPresenterState.prototype, "loader", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], EventListPresenterState.prototype, "showOddBtns", void 0);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "isMiniEventCard", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "tooltipMessage", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], EventListPresenterState.prototype, "toggleOddsBtnOnClick", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], EventListPresenterState.prototype, "updateProviderProps", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "isLoading", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "hasLoadEvents", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "preLiveOutrightShouldExpand", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "showLeagueInEventCard", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EventListPresenterState.prototype, "changeSubGrouping", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "displayMainHeadings", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "shouldHideSubheadings", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "displayFavoriteEvents", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "displayFavoriteLeagues", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "showFavoritesSection", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "shouldShowOutrightSubheading", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "isGroupedByTime", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], EventListPresenterState.prototype, "shouldShowNamesInHeadingForEvents", null);
//# sourceMappingURL=EventListPresenterState.js.map